/**
 * The columns in the support requests grid.
 */
export enum SupportRequestGridColumn {
  /**
   * The request ID.
   */
  Id = 'id',
  /**
   * The request status.
   */
  Status = 'status',
  /**
   * Time elapsed since the request was created.
   */
  ElapsedTime = 'elapsed-time',
  /**
   * Date to create the request
   */
  CreationDate = 'creation-date',
  /**
   * Time to resolve/close the request
   */
  ResolutionTime = 'resolution-time',
   /**
   * Request close date.
   */
  ResolutionDate = 'resolution-date',
  /**
   * The device name.
   */
  DeviceName = 'device-name',
  /**
   * The request type.
   */
  Type = 'type',
  /**
   * The assigned technician.
   */
  Technician = 'technician',
}
